// user reducer types
export const ROOT_LOADING = 'ROOT_LOADING'
export const ROOT_OUTSIDE = 'ROOT_OUTSIDE'
export const ROOT_INSIDE = 'ROOT_INSIDE'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
